module.exports = "../dist/img/img_2-19.e39b.jpg";